import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { Icon } from '../../../core/models/icon.model';
import { IconComponent } from '../icon/icon.component';
import { I18nPipe } from '../../pipes/i18n.pipe';

@Component({
  selector: 'umkt-highlight-card',
  standalone: true,
  imports: [CommonModule, IconComponent, I18nPipe],
  templateUrl: './highlight-card.component.html',
  styleUrls: ['./highlight-card.component.scss'],
})
export class HighlightCardComponent {
  private sanitizer = inject(DomSanitizer);


  @Input() title = '';
  @Input() subtitle = '';
  @Input() titleKey = '';
  @Input() subtitleKey = '';
  @Input() quantity = 1;

  // Option A: use app icon model (<umkt-icon>)
  @Input() icon?: Icon;

  // Option B: use raw icon class (e.g. mdn classes)
  @Input() iconClass = '';
  @Input() iconAriaLabel = 'icon';
  @Input() iconSvg = '';

  get shouldRenderIconComponent(): boolean {
    return !!this.icon;
  }

  get shouldRenderIconClass(): boolean {
    return !this.icon && this.iconClass.trim().length > 0;
  }

  get shouldRenderIconSvg(): boolean {
    return !this.icon && !this.iconClass && this.iconSvg.trim().length > 0;
  }

  get sanitizedIconSvg(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.iconSvg || '');
  }

  get cardIndexes(): number[] {
    const validQuantity = Number.isFinite(this.quantity)
      ? Math.max(1, Math.floor(this.quantity))
      : 1;

    return Array.from({ length: validQuantity }, (_, index) => index);
  }
}

